// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1xB_K","vLegacy":"SelectSecondary_vLegacy__2dUfz","error":"SelectSecondary_error__2gsrU","disabled":"SelectSecondary_disabled__3-5NW"};